import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { PolicyTabs } from 'core/store/account-store/policies-store/policy-store/policy-store';

import { useStore } from 'core/store';
import ChangesForApprovalSectionNonProcessingView from './changes-for-approval-section-non-processing-view';
import ChangesForApprovalSectionProcessingView from './changes-for-approval-section-processing-view';

const ChangesForApproval = ({
  closePolicyPreviewModal,
  showProofOfEligibilityDocumentsBlock,
  showAllHouseholdResidentsIncludedBlock,
  showNewPIPFormRequiredBlock,
  canApproveUWReview,
  previewId
}) => {
  const {
    account: {
      policies: {
        policy: {
          policy: { id },
          setCurrentTab,
          setScrollTo
        }
      }
    }
  } = useStore();

  const goToPIPCoverageSection = () => {
    setScrollTo('personalInjuryProtectionSection');
    setCurrentTab(PolicyTabs.DETAILS);
  };

  const openMemberDocuments = () => {
    const accountId = id?.split('-')[0];
    window.open(`${window.location.origin}/customer/${accountId}?scrollTo=memberDocuments`, '_blank');
  };

  return canApproveUWReview ? (
    <ChangesForApprovalSectionProcessingView
      closePolicyPreviewModal={closePolicyPreviewModal}
      showProofOfEligibilityDocumentsBlock={showProofOfEligibilityDocumentsBlock}
      showAllHouseholdResidentsIncludedBlock={showAllHouseholdResidentsIncludedBlock}
      showNewPIPFormRequiredBlock={showNewPIPFormRequiredBlock}
      goToPIPCoverageSection={goToPIPCoverageSection}
      openMemberDocuments={openMemberDocuments}
      previewId={previewId}
    />
  ) : (
    <ChangesForApprovalSectionNonProcessingView
      closePolicyPreviewModal={closePolicyPreviewModal}
      showProofOfEligibilityDocumentsBlock={showProofOfEligibilityDocumentsBlock}
      showAllHouseholdResidentsIncludedBlock={showAllHouseholdResidentsIncludedBlock}
      showNewPIPFormRequiredBlock={showNewPIPFormRequiredBlock}
      goToPIPCoverageSection={goToPIPCoverageSection}
      openMemberDocuments={openMemberDocuments}
      previewId={previewId}
    />
  );
};

ChangesForApproval.propTypes = {
  closePolicyPreviewModal: PropTypes.func.isRequired,
  showProofOfEligibilityDocumentsBlock: PropTypes.bool.isRequired,
  showAllHouseholdResidentsIncludedBlock: PropTypes.bool.isRequired,
  showNewPIPFormRequiredBlock: PropTypes.bool.isRequired,
  canApproveUWReview: PropTypes.bool.isRequired,
  previewId: PropTypes.string.isRequired
};

export default observer(ChangesForApproval);
